import { type TFunction } from 'i18next'
import { ComparisonTable } from 'ui/src/components/ComparisonTable/ComparisonTable'
import {
  type ComparisonTableBody,
  type ComparisonTableProps,
} from 'ui/src/components/ComparisonTable/ComparisonTable.types'
import { type TierComparison } from './fetchTierComparison'

// Generic comparison table is used for other things than tier coverage, so it has more abstract data structure
export function tierComparisonToTable(
  tierComparison: TierComparison,
  options: { t: TFunction; selectedTermsVersion?: string; showCoverageText?: boolean; showPerilColor?: boolean },
): { table: ComparisonTableProps; selectedTierDisplayName?: string } {
  let selectedTierDisplayName
  if (options.selectedTermsVersion) {
    selectedTierDisplayName = tierComparison.variantColumns.find(
      (col) => col.termsVersion === options.selectedTermsVersion,
    )?.displayNameSubtype
  }

  const head = ['', ...tierComparison.variantColumns.map((col) => col.displayNameSubtype)]
  const body: ComparisonTableBody = tierComparison.rows.map((row) => [
    {
      title: row.title,
      description: row.description,
      perilsColor: options.showPerilColor ? row.colorCode : undefined,
      coverageList: row.covered,
    },
    ...row.cells.map((cell, index) => {
      if (cell.coverageText && options.showCoverageText) {
        return cell.coverageText
      } else if (cell.isCovered) {
        return <ComparisonTable.CoveredIcon key={index} aria-label={options.t('COVERED')} />
      } else {
        return <ComparisonTable.NotCoveredIcon key={index} aria-label={options.t('NOT_COVERED')} />
      }
    }),
  ])
  return { table: { head, body }, selectedTierDisplayName }
}
